import * as React from "react";
import classnames from "classnames";
import { Icon } from "@grandvisionhq/icons";
/* empty css                       */
const MyCurrentLocation = ({ label, className, ...rest }) => /* @__PURE__ */ React.createElement("div", { ...rest, className: classnames("my-current-location-stores-v2", className) }, /* @__PURE__ */ React.createElement(Icon, { name: "gps" }), /* @__PURE__ */ React.createElement("span", { className: "my-current-location-stores-v2__label" }, label));
export {
  MyCurrentLocation as default
};
//# sourceMappingURL=MyCurrentLocation.js.map
